import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import Vue from 'vue';
import Cron from '@/components/Cron/Cron';
import Base from '../Base';
import { Popover, Button, Input, Tabs, TabPane, Row, Col, Radio, InputNumber, Select, Option } from 'element-ui';
var components = [Popover, Button, Input, Tabs, TabPane, Row, Col, Radio, InputNumber, Select, Option];
components.forEach(function (comp) {
  Vue.use(comp);
});
export default {
  name: 'MyCron',
  mixins: [Base],
  components: {
    Cron: Cron
  },
  props: {
    value: String,
    placeholder: {
      type: String,
      default: '请输入定时策略'
    }
  },
  data: function data() {
    return {
      cronPopover: false,
      cron: ''
    };
  },
  watch: {
    cron: {
      handler: function handler(val) {
        this.fieldValue = val;
        this.$emit('change', val);
      }
    },
    value: {
      immediate: true,
      handler: function handler(val) {
        this.cron = val;
      }
    },
    fieldValue: {
      immediate: true,
      handler: function handler(val) {
        this.cron = val;
      }
    }
  },
  methods: {
    changeCron: function changeCron(val) {
      this.cron = val;
    },
    hidePopover: function hidePopover() {
      this.cronPopover = false;
    }
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var vnode = h("el-popover", {
      "attrs": {
        "disabled": this.disabled || this.readonly
      },
      "model": {
        value: _this.cronPopover,
        callback: function callback($$v) {
          _this.cronPopover = $$v;
        }
      }
    }, [h(Cron, {
      "props": _objectSpread({}, {
        i18n: 'cn'
      }),
      "on": _objectSpread({}, {
        change: this.changeCron,
        close: this.hidePopover
      })
    }), h("el-input", {
      "slot": 'reference',
      "attrs": {
        "clearable": true,
        "disabled": this.disabled,
        "readonly": this.readonly,
        "placeholder": this.placeholder
      },
      "model": {
        value: _this.cron,
        callback: function callback($$v) {
          _this.cron = $$v;
        }
      }
    })]);
    return this.renderComponent(vnode);
  }
};